var accordions = [].slice.call(document.querySelectorAll('.accordion button, .states-list button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function(e) {
		if(e.target.tagName == 'A')
			return;

		var parent = this.parentNode,
			answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		if(!this.closest('section.full_accordion') || checkWidth(1024))
			Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		answer.setAttribute('aria-expanded', (answer.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		setTimeout(function() {
			if(parent.parentNode.classList.contains('states-list') && checkWidth(768))
				scrollToElement(parent);
		}, 500);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		var answer = openAccordion.nextSibling;

		if(!openAccordion.closest('section.full_accordion') || checkWidth(1024)) {
			Velocity(answer, 'slideUp', {duration: 250});
		}

		openAccordion.classList.toggle('open');

		answer.setAttribute('aria-expanded', 'false');
	}
}